// src/pages/RegistrationForm.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase'; // Firebase bağlantınızın doğru olduğundan emin olun
import { ref, set, get } from 'firebase/database'; // Firebase modüllerini import edin

// **Yeni Kod Tanımlaması**
const VALID_CODES = ['ABCDE', 'EDU123'];

function formatPhoneNumber(value) {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length === 0) return '';
  if (cleaned.length < 4) return `(${cleaned}`;
  if (cleaned.length < 7) return `(${cleaned.slice(0, 3)})-${cleaned.slice(3)}`;
  return `(${cleaned.slice(0, 3)})-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
}

export default function RegistrationForm() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '',
    lastName: '',
    email: '',
    phone: '',
    jobTitle: '',
    code: '', // registration code field
  });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === 'phone' ? formatPhoneNumber(value) : value,
    }));
  };

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = 'First Name is required';
    if (!form.lastName.trim()) errs.lastName = 'Last Name is required';
    if (!form.email.trim()) errs.email = 'Email is required';
    if (!form.phone.trim()) errs.phone = 'Phone is required';
    else if (form.phone.replace(/\D/g, '').length !== 10)
      errs.phone = 'Phone number must be 10 digits';

    // **GÜNCELLEME 1: Kariyer koçluğu (ABCDE) için Job Title'ı zorunlu tutmaya devam et.**
    // Eğer kod 'ABCDE' ise VEYA kod geçerli olmasına rağmen boş bırakılmışsa (eski mantığı korumak için)
    if (form.code === 'ABCDE' && !form.jobTitle.trim()) {
      errs.jobTitle = 'Job title is required for this career program';
    }
    // NOT: EDU123 kodu için jobTitle artık zorunlu değildir.

    // **GÜNCELLEME 2: İki kodu da geçerli kabul et.**
    if (!VALID_CODES.includes(form.code))
      errs.code = 'Invalid registration code';

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    if (!validate()) return;

    try {
      // Use email as key
      const emailKey = form.email.replace('.', '_');
      const snapshot = await get(ref(db, `students/${emailKey}`));
      if (snapshot.exists()) {
        setSubmitError('Email already registered. Please login.');
        return;
      }

      // **GÜNCELLEME 3: Kayıt kodunu (accessCode) Firebase'e kaydet.**
      await set(ref(db, `students/${emailKey}`), {
        ...form,
        createdAt: new Date().toISOString(),
        accessCode: form.code, // Bu, CodeInput'ta yönlendirme için kullanılacak
      });

      // Redirect to login with prefilled email
      navigate('/login', { state: { email: form.email } });
    } catch (err) {
      console.error(err);
      setSubmitError('Failed to register. Try again.');
    }
  };

  return (
    <div className='min-h-screen bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100 flex items-center justify-center px-4'>
      <form
        onSubmit={handleSubmit}
        className='w-full max-w-lg bg-white shadow-xl rounded-xl p-8 space-y-6'
      >
        <h2 className='text-3xl font-extrabold text-center text-indigo-700 mb-4'>
          Registration Form
        </h2>

        <input
          name='code'
          value={form.code}
          onChange={handleChange}
          placeholder='Enter Registration Code' //Registration Code (e.g., ABCDE or EDU123)'
          className='w-full rounded-lg border px-4 py-3'
        />
        {errors.code && <p className='text-red-600 text-xs'>{errors.code}</p>}

        <input
          name='name'
          value={form.name}
          onChange={handleChange}
          placeholder='First Name'
          className='w-full rounded-lg border px-4 py-3'
        />
        {errors.name && <p className='text-red-600 text-xs'>{errors.name}</p>}

        <input
          name='lastName'
          value={form.lastName}
          onChange={handleChange}
          placeholder='Last Name'
          className='w-full rounded-lg border px-4 py-3'
        />
        {errors.lastName && (
          <p className='text-red-600 text-xs'>{errors.lastName}</p>
        )}

        <input
          name='email'
          value={form.email}
          onChange={handleChange}
          placeholder='Email'
          className='w-full rounded-lg border px-4 py-3'
        />
        {errors.email && <p className='text-red-600 text-xs'>{errors.email}</p>}

        <input
          name='phone'
          value={form.phone}
          onChange={handleChange}
          placeholder='Phone'
          maxLength={14}
          className='w-full rounded-lg border px-4 py-3'
        />
        {errors.phone && <p className='text-red-600 text-xs'>{errors.phone}</p>}

        {/* Job Title alanı, sadece ABCDE kodu için zorunlu (Validation'da kontrol ediliyor) */}
        <input
          name='jobTitle'
          value={form.jobTitle}
          onChange={handleChange}
          placeholder='Job Title (Career Coaching)'
          className='w-full rounded-lg border px-4 py-3'
        />
        {errors.jobTitle && (
          <p className='text-red-600 text-xs'>{errors.jobTitle}</p>
        )}

        {submitError && (
          <p className='text-red-600 text-center'>{submitError}</p>
        )}

        <button
          type='submit'
          className='w-full bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700 transition'
        >
          Register
        </button>
      </form>
    </div>
  );
}
